/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('search-bar')
export default class SearchBar extends Component {
  // Consts
  enterCode = 13;

  // Params
  debounceDelay = 300;

  onSearch() {}

  // State
  @tracked
  searchQuery = '';

  boundOnKeyPress = null;

  init() {
    super.init(...arguments);
    this.boundOnKeyPress = this.onKeyPress.bind(this);
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    window.addEventListener('keypress', this.boundOnKeyPress);
  }

  willDestroy() {
    window.removeEventListener('keypress', this.boundOnKeyPress);
    super.willDestroy(...arguments);
  }

  onKeyPress(key) {
    if (key.keyCode === this.enterCode) {
      this.onSearch(this.searchQuery);
    }
  }

  @action
  searchPosts() {
    this.onSearch(this.searchQuery);
  }

  @action
  onChange(query) {
    this.searchQuery = query;
    if (query === '') {
      this.onSearch(this.searchQuery);
    }
  }
}
